module.exports = __webpack_public_path__ + "img/物流.9a7137cf.png";